<template>
  <div>
    <h1>KPI</h1>
    <div class="row">
      <div class="col-md-4">
        <c-box>
          <h4>KPI 1</h4>
          <p>Срок по задачам</p>
        </c-box>
      </div>
      <div class="col-md-4">
        <c-box>
          <h4>KPI 2</h4>
          <p>Тональность поисковой выдачи</p>
        </c-box>
      </div>
      <div class="col-md-4">
        <c-box>
          <h4>KPI 3</h4>
          <p>Мониторинг/коммуникация</p>
        </c-box>
      </div>
    </div>
    <button
      class="btn background-white border-danger text-danger"
      type="button"
    >
      +  Добавить KPI
    </button>
  </div>
</template>

<script>
import CBox from '../../../../../../resources/js/components/ui/CBox'

export default {
  name: 'KPI',
  components: { CBox },

  data: () => ({
    isLoading: false
  })
}
</script>
